import React, { Component } from 'react';
import { partnerApi, getAllverticalData, getAllcategoryData } from  './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import config from "./../../../../API/DomainName";

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../../../constant';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';
class About_other extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      about: '',
      tobecurated:false,
      main_access: '',
      maxAbout: 0,
      page_data: [],
      user_type: 0,
      active_status: 0,
      organisation_name: '',
      banner_image: '',
      main_category: '',
      slug_term: '',
      address: '',
      listcategories: [],
      collapse: 0,
      pageurl:'',
    }
    this.validator = new SimpleReactValidator();
    this.getAbout();
    this.toggle = this.toggle.bind(this);
    this.handleChangeAbout = this.handleChangeAbout.bind(this);
  }
  toggle(event) {
   
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });

  }
  countWords(str) {
    str = str.replace(/(^\s*)|(\s*$)/gi, "");
    str = str.replace(/[ ]{2,}/gi, " ");
    str = str.replace(/\n /, "\n");
    return str.split(' ').length;
  }
  componentDidMount() {

  }
  async getAbout() {
    const { user_type, login_id, set_id } = this.state.user_data;
    let insdata = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getAbout'
    });
    await partnerApi(insdata).then((response) => {
      if (response.status === 1) {

        this.setState({
          page_data: response.result.master_data,
          active_status: response.result.active_status,
          maxAbout: 500,
          pageurl:response.result.pageurl
        })
 
      }
    });
  }
  handleChange = (e, i) => {
    const propName = e.target.name;
    let page_data = this.state.page_data;
    page_data[i][propName] = e.target.value;
    this.setState({ page_data });
  };

 
  handleChangeAbout(value, i) {
    let page_data = this.state.page_data;
    page_data[i]['about'] = value;
    this.setState({ page_data });
}
  handleCheckBoxChange= (e, i) => {
    let page_data = this.state.page_data;
    const propName = e.target.name;
     if(e.target.checked){
      page_data[i][propName] = 1;
     }else{
      page_data[i][propName] = 0;
     }
     this.setState({page_data});
  };
  
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  };
  render() {
    const { cards, collapse, page_data, pageurl} = this.state;
    this.validator.purgeFields();
    return (
      <React.Fragment>
        
        <div class="category_block">

        <div class="titleline">
          <h4>About Info</h4> <span>Branch Information is copied from Head Office by default, You can edit and update as it may be required</span>
        </div>

        <div className="">
         
          {page_data.map((item, index) => {
            return (
              <div class="eachblockgap" style={{paddingTop:"20px"}}>
                            
              <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                <CardHeader onClick={() => this.toggle(index)} data-event={index} className={item.set_id!=1?"branchcss":"maincss"}>
                  
                  <div class="infoBoxColor">

                    <div class="org_item">
                      <div class="label_n">Category:</div>
                      <div class="item_n">{item.category_name}</div>
                    </div>
                    <div class="org_item">
                      <div class="label_n">Inst/Org Name:</div>
                      <div class="item_n item_n_name">{item.organisation_name}</div>
                    </div>
                    <div class="org_item">
                      <div class="label_n">Sub Category</div>
                      <div class="item_n">{item.sub_category_name ? item.sub_category_name : ''}</div>
                    </div>
                    <div class="org_item">
                      <div class="label_n">Type:</div>
                      <div className={item.set_id!=1?"item_n branchtext":"item_n"}>{item.set_id!=1?"Branch":"HQ"}</div>
                    </div>

                  </div>
                   
                  {collapse !== index ? (
                   <div class="centeredexpcolbtn"><span className=''>
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </span></div>
                  ) : (
                    <div class="centeredexpcolbtn"><span className=''>
                      <i class="fa fa-minus" aria-hidden="true"></i>
                    </span></div>
                  )}
                  <br/>
                </CardHeader>
                <Collapse className={(collapse === index)?"expanded":""} isOpen={collapse === index}>
                  <CardBody className='panel-body'>

                  <h3 className="page-header">{item.organisation_name} <span style={{fontSize:"10px"}}><b>{item.set_id==3?"Branch":""}</b></span></h3>
                  <p className='mar-btm'>{item.address}</p>

                    {item.is_active == 0 ?
                      (
                        <div className='row mar-btm'>
                          <div class="form-group col-md-12">
                            <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                          </div>
                        </div>
                      ) :
                      (
                        <form onSubmit={(e) => this.submitForm(e, index)}>
                           
                          <div className='row mar-btm'>
                            <div class="form-group col-md-12">
                            <Editor
                              onEditorChange={(e) => this.handleChangeAbout(e, index)}
                              value={item.about}
                              apiKey={TINY_EDITOR}
                              init={{
                                height: 400,
                                plugins: [
                                  'lists link image paste'
                                ],
                                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                              }}
                                />

                              
                            </div>
                          </div>

                           { item.category_name=='Learning Camps' ? (
                           <div className='row mar-btm'>
                            <div class="form-group col-md-12">
                             <label>
                               Send as request to be BeWise Curated
                             </label>
                             <input type="checkbox" name="iscurated" onChange={(e) => this.handleCheckBoxChange(e, index)} />
                            </div>
                          </div>
                          ) : ''}

                          <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                            <button type='submit' id="btnSubmit"
                              className="btn btn-primary btn-sm">
                              Submit About info
                            </button>
                          </div>

                        </form>
                      )
                    }

                  </CardBody>
                </Collapse>
              </Card>
              </div>
            )
          })}
        </div>

        </div>
        <NotificationContainer/>
      </React.Fragment>
    );
  }

  handleChangeParent = (event) => {
    this.props.handleChange();
  };


  submitForm = (e, i) => {
    e.preventDefault();
    let page_data = this.state.page_data;
    let count = this.countWords(page_data[i].about);
    if (count > this.state.maxAbout) {
       
      NotificationManager.error('The about must be less than ' + this.state.maxAbout + ' words.');
      return false;
    }
    // if (this.validator.allValid()) {
    const { user_type, login_id, set_id } = this.state.user_data;
    let request = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      main_access: this.state.main_access,
      active_status: this.state.active_status,
      data: page_data[i],
      url: 'updateAbout'
    });
    partnerApi(request).then(res => {
      
      if (res.status === 1) {
        //console.log("dfgdgfd");
        //this.handleChangeParent();
        NotificationManager.success(res.message);

      } else {
        NotificationManager.error(res.message);
      }
      
    });
    // } else {
    //   this.validator.showMessages();
    //   this.forceUpdate();
    // }
  };
}

export default About_other;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/other_info/about_otherV3.jsx